export class HospitalsModel{
  hoscode = '' ;
  hosname = '' ;
  hosnotes = '' ;
  compcode = '' ;
  userid = '' ;
  modifieddate = '2021-01-01' ;


}
